module.exports = __webpack_public_path__ + "img/team-ncy.fb28b12.jpg";